const pageNameKey = "noDataInTimeframe";

export const noDataInTimeframeEn = {
  [pageNameKey]: {
    noDataInTimeframe: "No data available in this timeframe",
  },
};

export const noDataInTimeframePtBr = {
  [pageNameKey]: {
    noDataInTimeframe: "Nenhum dado disponível neste período",
  },
};

export const noDataInTimeframeDe = {
  [pageNameKey]: {
    noDataInTimeframe: "Keine Daten für diesen Zeitraum verfügbar",
  },
};

export const noDataInTimeframeZhHans = {
  [pageNameKey]: {
    noDataInTimeframe: "此时间段内没有可用数据",
  },
};

export const noDataInTimeframeIt = {
  [pageNameKey]: {
    noDataInTimeframe: "Nessun dato disponibile in questo periodo",
  },
};

export const noDataInTimeframeEs = {
  [pageNameKey]: {
    noDataInTimeframe: "No hay datos disponibles en este período",
  },
};

export const noDataInTimeframeNl = {
  [pageNameKey]: {
    noDataInTimeframe: "Geen gegevens beschikbaar in deze periode",
  },
};

export const noDataInTimeframeTr = {
  [pageNameKey]: {
    noDataInTimeframe: "Bu zaman diliminde veri yok",
  },
};
